import { Negocio } from "../types/negocio.type";

export const USER_TOKEN_KEY_V2 = "faster_negocios_userTokenNegocios-V2";
export const USER_KEY_V2 = "faster_negocios_userNegocios-V2";
export const NEGOCIO_ACTIVO_KEY_V2 = "faster_negocios_negocioActivo-V2";

const getToken = () => {
  return localStorage.getItem(USER_TOKEN_KEY_V2);
};

const saveToken = (token: string) => {
  localStorage.setItem(USER_TOKEN_KEY_V2, token);
};

const saveNegocioActivo = (negocio: Negocio) => {
  localStorage.setItem(NEGOCIO_ACTIVO_KEY_V2, JSON.stringify(negocio));
};

const getNegocioActivo = () => {
  const value = localStorage.getItem(NEGOCIO_ACTIVO_KEY_V2);
  if (value) {
    return JSON.parse(value);
  }

  return null;
};

const deleteToken = () => {
  localStorage.removeItem(USER_TOKEN_KEY_V2);
  localStorage.removeItem(NEGOCIO_ACTIVO_KEY_V2);
};

const isAuthenticated = () => {
  return !!getToken();
};

const getUser = async () => {
  const value = await localStorage.getItem(USER_KEY_V2);
  if (value) {
    return JSON.parse(value);
  }
  return null;
};

const getNegocioId = () => {
  return getNegocioActivo()?.id;
};

export const authUtils = {
  getToken,
  saveToken,
  saveNegocioActivo,
  getNegocioActivo,
  deleteToken,
  isAuthenticated,
  getUser,
  getNegocioId,
};
